import { BsEnvelopeFill, BsTelephoneFill, BsQuestionCircleFill } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';
import Page from '#globalComponents/Page/Page';
import PageHeader from '#globalComponents/PageHeader/PageHeader';

const SupportPage = () => {
	return (
		<Page header={<PageHeader title="Support" subtitle="Hilfe & Kontakt" breadcrumbs={['Support']} />}>
			<div>
				{/* Contact Cards Grid */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
					{/* Email Card */}
					<Card className="p-6">
						<div className="flex flex-col items-center text-center">
							<div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
								<BsEnvelopeFill className="text-lg text-primary-600" />
							</div>
							<h3 className="text-lg font-semibold text-text mb-2">E-Mail Support</h3>
							<p className="text-sm text-text mb-4">
								Schreiben Sie uns eine E-Mail und wir melden uns schnellstmöglich bei Ihnen.
							</p>
							<a
								href="mailto:info@b2b-hero.com"
								className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 hover:text-white"
							>
								<BsEnvelopeFill className="text-lg" />
								info@b2b-hero.com
							</a>
						</div>
					</Card>

					{/* Phone Card */}
					<Card className="p-6">
						<div className="flex flex-col items-center text-center">
							<div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
								<BsTelephoneFill className="text-lg text-primary-600" />
							</div>
							<h3 className="text-lg font-semibold text-text mb-2">Telefon Support</h3>
							<p className="text-sm text-text mb-4">
								Rufen Sie uns an für schnelle Hilfe bei dringenden Anliegen.
							</p>
							<a
								href="tel:+4953319327360"
								className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 hover:text-white"
							>
								<BsTelephoneFill className="text-lg" />
								05331 9327360
							</a>
						</div>
					</Card>
				</div>

				{/* Support Hours Info */}
				<Card className="p-6 bg-primary-100 border-primary-200">
					<div className="flex items-start gap-4">
						<div className="w-12 h-12 bg-primary-200 rounded-full flex items-center justify-center flex-shrink-0">
							<BsQuestionCircleFill className="text-lg text-primary-700" />
						</div>
						<div>
							<h4 className="text-lg font-semibold text-text mb-2">Support-Zeiten</h4>
							<div className="text-md text-text space-y-1">
								<p>
									<strong>Montag - Freitag:</strong> 09:00 - 18:00 Uhr
								</p>
								<p>
									<strong>Wochenende:</strong> Geschlossen
								</p>
								<p className="text-sm text-text mt-3">
									E-Mails werden auch außerhalb der Geschäftszeiten bearbeitet und wir melden uns
									spätestens am nächsten Werktag bei Ihnen.
								</p>
							</div>
						</div>
					</div>
				</Card>
			</div>
		</Page>
	);
};

export default SupportPage;
